import { z } from 'zod';

export const requestDeletionSchema = z.object({
  email: z.string().trim().toLowerCase().email('Enter the email address on your Shoutt account'),
});

export const deletionCodeSchema = z
  .string()
  .trim()
  .regex(/^\d{4}$/, 'Enter the 4-digit code from your email');
